"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERROR = exports.COMPLETED = exports.PAYMENT_PENDING = exports.REJECTED = exports.ACCEPTED = exports.PENDING = void 0;
exports.PENDING = 'PENDING';
exports.ACCEPTED = 'ACCEPTED';
exports.REJECTED = 'REJECTED';
exports.PAYMENT_PENDING = 'PAYMENT_PENDING';
exports.COMPLETED = 'COMPLETED';
exports.ERROR = 'ERROR';
